import { FormatType } from "@/hooks/useDateFormatter";
import { OnOffBoardLog } from "@/types/OnOffBoardLogs";
import { createColumnHelper } from "@tanstack/react-table";
import { format as formatFns } from "date-fns";

const columnHelper = createColumnHelper<OnOffBoardLog>();

export const getColumns = (format: FormatType) => {
	return [
		columnHelper.accessor("user", {
			header: "User",
			cell: (info) => info.getValue(),
		}),
		columnHelper.accessor("changedBy", {
			header: "Changed By",
			cell: (info) => info.getValue(),
		}),
		columnHelper.accessor("previousValue", {
			header: "Before",
			cell: (info) => (info.getValue() === 1 ? "In" : "Out"),
		}),
		columnHelper.accessor("newValue", {
			header: "After",
			cell: (info) => (info.getValue() === 1 ? "In" : "Out"),
		}),
		columnHelper.accessor("createdAt", {
			header: "Date",
			cell: (info) => {
				const date = new Date(info.getValue());
				return `${format(date)} at ${formatFns(date, "HH:mm")}`;
			},
		}),
	];
};
